/**
 * Every word on the pool screen's own top row.
 *
 * Plain American English, written inline and hardcoded to en-US, the way
 * `no-i18n.mdc` requires. Both labels name what the control does, so a screen
 * reader announces a destination rather than an icon.
 */

/** The back arrow. It names where back goes, not the gesture. */
export const POOL_BACK_LABEL = "Back to pools";

/** The share control, which is icon only, so this label is all a screen reader gets. */
export const POOL_SHARE_LABEL = "Share this pool";

/** The tab row's accessible name. Not rendered visually. */
export const POOL_TABS_LABEL = "Pool sections";

export const POOL_TAB_MEMBERS_LABEL = "Members";
export const POOL_TAB_SETTINGS_LABEL = "Settings";
export const POOL_TAB_GAME_LABEL = "Game";
export const POOL_TAB_RESULTS_LABEL = "Results";
